import PageHeader from "app/shared/PageHeader";
import "./Dashboard.scss";
import CustomReconTabs from "../Reconcilation/components/CustomReconTabs";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import posthog from 'posthog-js';
import { DASHBOARD_LINK_ZOHO_CRITERIA_FILTER } from "global.constants";
import { getSubdomain } from "app/utils/generic.helper";

import {
  onboardingMessageShown,
  tabViewStates,
  userInfo,
  workspaceReports,
} from "app/config/States/users";
import Loader from "app/shared/Loader";
import { Empty, Modal, Tabs } from "antd";
import Typography from "app/shared/Typography";
import EmptyState from "app/shared/EmptyState";
import ZAViewSelector from "app/shared/ZAViewSelector";
import { Mixpanel } from "app/config/Mixpanel";
import { colorPicker } from "app/utils/color.helper";
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
export default function AppDashboard(props: any) {
  const [activeKey, setActiveKey] = useState("");
  const [reports, setWorkspaceReports] = useRecoilState<any>(workspaceReports);
  const [tabViews, setTabView] = useRecoilState<any>(tabViewStates);
  const [isLoading, setLoading] = useState(false);
  const [userDetails, _] = useRecoilState<any>(userInfo);

  const [onboardingMessage, setShowOnboardingMessage] = useRecoilState<any>(
    onboardingMessageShown
  );
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  Mixpanel.track("User Landed On Dashboard", { Screen: "Dashboard" });
  const domain: any = getSubdomain();
  useEffect(() => {
    if (reports?.dashboards && reports?.dashboards.length > 0) {
      setActiveKey(reports.dashboards[0].embedurl);
    }
    // else {
    //   setActiveKey("Credential");
    // }

    const hostname = window.location.hostname;
    const isLocalhost =
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname === "";


      if (!isLocalhost && userDetails?.email) {
        const email = userDetails.email.toLowerCase();
        const blockDomains = ["kgrp.in", "finkraft.ai"];
        const userDomain = email.split("@")[1];
    
        if (!blockDomains.includes(userDomain)) {
          const subdomain = hostname.split(".")[0];
    
          posthog.identify(userDetails.id, {
            name: userDetails.name,
            email: userDetails.email,
            workspace_name: userDetails.currentWorkspace?.name,
            subdomain: subdomain,
          });
    
          FinkAnalytics("navbar_option_clicked", {
            option_name: "Dashboard",
            workspace_name: userDetails.currentWorkspace?.name,
            subdomain: subdomain,
          });
    
          posthog.capture("user_details_captured", {
            name: userDetails.name,
            email: userDetails.email,
            workspace_name: userDetails.currentWorkspace?.name,
            subdomain: subdomain,
            access_date: new Date().toISOString().split("T")[0],
          });
        } else {
         
          posthog.reset(); // user/session is cleared
        }
      }
      
    if (!onboardingMessage) setShowModal(true);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [reports]);

  const handleRedirectOnboarding = () => {
    setShowOnboardingMessage(true);
    // setActiveKey("Credential");
    // setShowModal(false);
    navigate("/integrations");
  };

  const getCredentialDashboardLink = () => {
    let link =
      "https://analytics.zoho.in/open-view/103074000038657277/3b131ffff66b66a9688aaeeddc4fa06d";
    if (userDetails.currentWorkspace?.name.includes("Admin")) {
      return link;
    } else {
      const workspaceName = userDetails.currentWorkspace?.name;
      // Encode the workspace name to make it URL-safe
      const encodedWorkspaceName = encodeURIComponent(workspaceName);
      // Build the filter key
      const filterKey =
        DASHBOARD_LINK_ZOHO_CRITERIA_FILTER[domain]?.[activeKey] || "workspace";
      // Combine pre-encoded key/value structure with encoded workspace name
      const actualUrl = `${link}?ZOHO_CRITERIA=%22${filterKey}%22%3D%27${encodedWorkspaceName}%27`;
      return actualUrl;
    }
  };
  return isLoading ? (
    <Loader />
  ) : (
    <div className="Dashboard">
      <div className="ScreenContainer">
        <PageHeader
          title={
            // !reports?.dashboards || reports?.dashboards?.length === 0
            //   ? ""
            //   : "Dashboard"
            "Dashboard"
          }
          leftActions={
            <div style={{ display: "flex", alignItems: "center" }}>
              <ZAViewSelector
                activeKey={activeKey === "Credential" ? "" : activeKey}
                items={reports?.dashboards || []}
                onViewChange={(data: any, fullObj: any) => setActiveKey(data)}
              />
              <div style={{ marginLeft: 12 }}>
                <Tabs
                  items={[
                    { key: "Credential", label: "Dashboard - Credential" },
                  ]}
                  tabBarStyle={{
                    borderBottom: "none", // Remove the underline border
                    margin: 0,
                  }}
                  activeKey={activeKey}
                  onChange={(tabItem: string) => setActiveKey(tabItem)}
                />
              </div>
            </div>
          }
        />

        <div className="TableContainer">
          {activeKey === "Credential" ? (
            <div style={{ height: "100%" }}>
              <iframe
                height="100%"
                style={{ width: "100%" }}
                scrolling="no"
                title="Iframe"
                src={getCredentialDashboardLink()}
              ></iframe>
            </div>
          ) : !reports?.dashboards || reports?.dashboards?.length === 0 ? (
            <EmptyState
              title="No Dashboards Available"
              description="Try changing workspace for dashboard view"
            />
          ) : (
            <div style={{ height: "100%" }}>
              <iframe
                height="100%"
                style={{ width: "100%" }}
                scrolling="no"
                title="Iframe"
                src={activeKey}
              ></iframe>
            </div>
          )}
        </div>
      </div>
      <Modal
        title={false}
        footer={false}
        open={showModal}
        closable={false}
        width={500}
        centered
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">
            {" "}
            <ExclamationCircleFilled
              style={{ marginRight: 4, color: "#e67e22" }}
            />
            Require immediate action
          </Typography>
          <Typography
            variant="xs"
            style={{ color: "#7e7979", textAlign: "center", marginTop: 6 }}
          >
            Onboarding steps pending , you will be redirected to on boarding
            dashboard review the data sets which are missing then go to
            integration tab and complete the pending items.{" "}
            <Button
              style={{ cursor: "pointer", color: "white", backgroundColor:"rgb(10, 131, 148)", marginTop:"25px" }}
              onClick={handleRedirectOnboarding}
            >
              Complete Now
            </Button>
          </Typography>
        </div>
      </Modal>
    </div>
  );
}
